import React from "react";

const TermsAndConditions = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
      <h1>Terms and Conditions for Kalingo Inc.</h1>
      <p style={{paddingLeft: "10px"}}>
        Welcome to Kalingo Inc. These terms and conditions outline the rules and
        regulations for the use of KalingoTV's Website, located at kalingo.tv.
      </p>
      <p style={{paddingLeft: "10px"}}>
        By accessing this website we assume you accept these terms and
        conditions. Do not continue to use KalingoTV if you do not agree to take
        all of the terms and conditions stated on this page.
      </p>

      <h2>1. Intellectual Property Rights</h2>
      <p style={{paddingLeft: "10px"}}>
        Other than the content you own, under these Terms, KalingoTV and/or its
        licensors own all the intellectual property rights and materials
        contained in this Website.
      </p>

      <h2>2. Restrictions</h2>
      <p style={{paddingLeft: "10px"}}>You are specifically restricted from all of the following:</p>
      <ul>
        <li>publishing any Website material in any other media;</li>
        <li>
          selling, sublicensing and/or otherwise commercializing any Website
          material;
        </li>
        <li>publicly performing and/or showing any Website material;</li>
        <li>
          using this Website in any way that is or may be damaging to this
          Website;
        </li>
        <li>
          using this Website in any way that impacts user access to this
          Website;
        </li>
        <li>
          using this Website contrary to applicable laws and regulations, or in
          any way may cause harm to the Website, or to any person or business
          entity;
        </li>
        <li>
          engaging in any data mining, data harvesting, data extracting or any
          other similar activity in relation to this Website;
        </li>
        <li>using this Website to engage in any advertising or marketing.</li>
      </ul>

      <h2>3. Your Content</h2>
      <p style={{paddingLeft: "10px"}}>
        In these Website Standard Terms and Conditions, "Your Content" shall
        mean any audio, video text, images or other material you choose to
        display on this Website. By displaying Your Content, you grant KalingoTV
        a non-exclusive, worldwide irrevocable, sub licensable license to use,
        reproduce, adapt, publish, translate and distribute it in any and all
        media.
      </p>

      <h2>4. No warranties</h2>
      <p style={{paddingLeft: "10px"}}>
        This Website is provided "as is," with all faults, and KalingoTV express
        no representations or warranties, of any kind related to this Website or
        the materials contained on this Website.
      </p>

      <h2>5. Limitation of liability</h2>
      <p style={{paddingLeft: "10px"}}>
        In no event shall KalingoTV, nor any of its officers, directors and
        employees, shall be held liable for anything arising out of or in any
        way connected with your use of this Website whether such liability is
        under contract. KalingoTV, including its officers, directors and
        employees shall not be held liable for any indirect, consequential or
        special liability arising out of or in any way related to your use of
        this Website.
      </p>

      <h2>6. Indemnification</h2>
      <p style={{paddingLeft: "10px"}}>
        You hereby indemnify to the fullest extent KalingoTV from and against
        any and/or all liabilities, costs, demands, causes of action, damages
        and expenses arising in any way related to your breach of any of the
        provisions of these Terms.
      </p>

      <h2>7. Severability</h2>
      <p style={{paddingLeft: "10px"}}>
        If any provision of these Terms is found to be invalid under any
        applicable law, such provisions shall be deleted without affecting the
        remaining provisions herein.
      </p>

      <h2>8. Variation of Terms</h2>
      <p style={{paddingLeft: "10px"}}>
        KalingoTV is permitted to revise these Terms at any time as it sees fit,
        and by using this Website you are expected to review these Terms on a
        regular basis.
      </p>

      <h2>9. Governing Law & Jurisdiction</h2>
      <p style={{paddingLeft: "10px"}}>
        These Terms will be governed by and interpreted in accordance with the
        laws of the State of Las Vegas (Newada), and you submit to the
        non-exclusive jurisdiction of the state and federal courts located in
        Las Vegas (Newada) for the resolution of any disputes.
      </p>

      <p style={{paddingLeft: "10px"}}>
        If you have any questions about these Terms, please contact us at{" "}
        <a href="mailto:contact@kalingo.tv">contact@kalingo.tv</a>.
      </p>
    </div>
  );
};

export default TermsAndConditions;
